import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "pt-2"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'SlideSelect',
  props: {
    modelValue: null,
    items: null,
    full: {
      type: Boolean
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const carousel = ref(null);
    const currentIndex = ref(props.items.findIndex(item => item === props.modelValue) ?? 0);
    onMounted(() => currentIndex.value = props.items.findIndex(item => item === props.modelValue));
    watch(() => props.modelValue, () => currentIndex.value = props.items.findIndex(item => item === props.modelValue));
    const onChange = currentIndex => emit('update:modelValue', props.items[currentIndex]);
    return (_ctx, _cache) => {
      const _component_NCarouselItem = _resolveComponent("NCarouselItem");
      const _component_NCarousel = _resolveComponent("NCarousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NCarousel, {
        "space-between": 30,
        loop: false,
        "slides-per-view": "auto",
        "centered-slides": "",
        class: "h-full",
        "show-arrow": "",
        "on-update:current-index": onChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, i) => {
          return _renderSlot(_ctx.$slots, "item-wrapper", _normalizeProps(_mergeProps({
            key: i
          }, {
            item
          })), () => [_createVNode(_component_NCarouselItem, {
            style: _normalizeStyle({
              width: __props.full ? `100%` : `40%`
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass([{
                'mb-8': !__props.full
              }, "child:pb-12 child:pt-8"])
            }, [_renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps({
              item
            })), () => [_createElementVNode("pre", null, _toDisplayString(item), 1)])], 2)]),
            _: 2
          }, 1032, ["style"])]);
        }), 128))]),
        _: 3
      })]);
    };
  }
});